<script>
import { mapGetters } from 'vuex'
import CommonContinueRegistration from '~/components/common/continue-registration.vue'

export default {
  name: 'StartTeachingSignupBanner',
  components: { CommonContinueRegistration },
  computed: {
    ...mapGetters('local', ['getJoinUs'])
  }
}
</script>

<template>
  <section class="signup-banner">
    <div class="text-center text-white">
      <p class="text__headline-5-xs--bold lg:text__headline-3-md--bold mb-3">
        {{ getJoinUs.headline }}
      </p>
      <p class="text__caption-xs--regular lg:text__body-2-md--regular">
        {{ getJoinUs.caption }}
      </p>
      <CommonContinueRegistration btn-class="mx-auto mt-4 lg:mt-8 lg:w-[250px] w-[190px]">
        <template #else>
          <BaseButton
            :label="$t('actions.signup_now')"
            size="xs-md"
            class="mx-auto mt-4 lg:mt-8 lg:w-[374px] w-[185px]"
            @click="$emit('signup')"
          />
        </template>
      </CommonContinueRegistration>
    </div>
  </section>
</template>

<style scoped lang="scss">
.signup-banner {
  @apply w-full h-[160px] lg:h-[550px] bg-cover bg-no-repeat flex items-center justify-center;
  background-image: url("@images/start-teaching/landing/sign-up-banner-start-teaching.jpg");
}
</style>
